import { render } from "./TopWorstSecondForm.vue?vue&type=template&id=38aa419a&scoped=true"
import script from "./TopWorstSecondForm.vue?vue&type=script&lang=js"
export * from "./TopWorstSecondForm.vue?vue&type=script&lang=js"

import "./TopWorstSecondForm.vue?vue&type=style&index=0&id=38aa419a&lang=scss&scoped=true"
import "./TopWorstSecondForm.vue?vue&type=style&index=1&id=38aa419a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38aa419a"]])

export default __exports__